document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  const splideElement = bar.querySelector('.splide');
  if (!splideElement) return;

  const slides = splideElement.querySelectorAll('.splide__slide');
  if (slides.length <= 1) return;

  const autoplaySpeed = parseInt(bar.getAttribute('data-autoplay-speed')) || 5000;

  if (typeof Splide !== 'undefined') {
    new Splide(splideElement, {
      type: 'fade',
      rewind: true,
      autoplay: true,
      interval: autoplaySpeed,
      arrows: false,
      pagination: false,
      drag: true,
      perPage: 1,
      perMove: 1
    }).mount();
  }
});
